import { AnyAction } from "redux";
import { Dispatch } from "react";
import { Result } from "../../../../interfaces";
import { getValidationResult } from "../../../import";
export const GET_VALIDATION_XLSX_DOCUMENT_REQUEST = 'GET_VALIDATION_XLSX_DOCUMENT_REQUEST';
export const GET_VALIDATION_XLSX_DOCUMENT_SUCCESS = 'GET_VALIDATION_XLSX_DOCUMENT_SUCCESS';
export const GET_VALIDATION_XLSX_DOCUMENT_FAILURE = 'GET_VALIDATION_XLSX_DOCUMENT_FAILURE';
export const GET_VALIDATION_XLSX_DOCUMENT = 'GET_VALIDATION_XLSX_DOCUMENT';
export const DEFAULT_IMPORT = 'DEFAULT_IMPORT';

interface ActionDefault<T> {
    type : string,
    payload  : T
}

interface ActionPagination<T> {
    type : string,
    payload  : T
}

const getValidationXlsxDocumentRequest = () => {
    return {
        type: GET_VALIDATION_XLSX_DOCUMENT_REQUEST,
    };
};

const getValidationXlsxDocumentSuccess = (data: any):ActionPagination<Result<any>> => {
    return {
        type: GET_VALIDATION_XLSX_DOCUMENT_SUCCESS,
        payload :data
    };
};

const getValidationXlsxDocumentFailure = (error: any) => {
    return {
        type: GET_VALIDATION_XLSX_DOCUMENT_FAILURE,
        payload: error,
    };
};
const getValidationXlsx = (data:any) => {
    return {
        type: GET_VALIDATION_XLSX_DOCUMENT,
        payload: data,
    };
}

export const setDefault = () => {
    return {
        type: DEFAULT_IMPORT
    };
}

export const getFileValidationResult = (fileid:string)=>  {
    return async (dispatch: Dispatch<AnyAction>) => {
         dispatch(getValidationXlsxDocumentRequest());
         try {
            const response = await getValidationResult(fileid);
            dispatch(getValidationXlsxDocumentSuccess(response.data));
         } catch (error:any) {
             dispatch(getValidationXlsxDocumentFailure(error.message));
         }
     };
 };
